import Head from "next/head";
import Navbar from "../../components/general/Navbar";
import Header from "../../components/general/Header";
import HiddenMenu from "../../components/general/HiddenMenu";
import SingleCategory from "../../components/product/SingleCategory";
import Footer from "../../components/general/Footer";
import {useState, useEffect} from "react";
import AuthServices from "../../services/Auth.services";
import {Input} from "../../components/form/elements/Input";
import Filter from "../../components/general/Filter";
import Checkbox from "../../components/form/elements/Checkbox";
import InfiniteScroll from "react-infinite-scroll-component";
import {useRouter} from "next/router";

export default function Index({
                                  navigation,
                                  loggedIn,
                                  jwtToken,
                                  offerteId,
                                  invoiceData,
                                  otherInvoices,
                                  categories,
                              }) {
    const router = useRouter();
    const [auth, setAuth] = useState(loggedIn);
    const [userInfo, setUserInfo] = useState();

    const offerteParam = offerteId ? "&offerte=" + offerteId : "";
    const [categoriesList, setCategories] = useState(categories);
    const [page, setPage] = useState(1);
    const [moreData, setMoreData] = useState(
        categoriesList.length < 20 ? false : true
    );

    useEffect(() => {
        if (!jwtToken) {
            return;
        }
        setUserInfo(AuthServices.getUserData(jwtToken));
    }, []);

    const fetchMoreData = async () => {
        setPage(page + 1);

        let newData = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
            "/api/categories?" +
            new URLSearchParams({
                limit: 20,
                page: page,
                category: router.query.category || "",
                query: router.query.query || "",
                subcategories: router.query.subcategories || "",
            }),
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        ).then((response) => {
            return response.json();
        });
        newData.length > 0
            ? setCategories(categoriesList.concat(newData))
            : setMoreData(false);
    };

    return (
        <div className="min-h-screen flex flex-col">
            <Head>
                <title>Olaf Nijenkamp | Categorieën</title>
                <meta name="description" content="Generated by create next app"/>
            </Head>

            <header>
                <Navbar items={navigation}/>
                <HiddenMenu loggedIn={loggedIn} role={userInfo?.role}/>
                <Header title="Categorieën" small={true}/>
            </header>

            <main className="olafGrid lg:grid lg:grid-cols-12 lg:gap-8 mt-4">
                <section className="mt-2.5 lg:mt-8 lg:col-start-10 lg:col-span-3">
                    <Filter>
                        <Checkbox
                            value={true}
                            name="subcategories"
                            text="Toon subcategorieën"
                        />
                        <Input name="query" text="Zoeken..." label="Zoekwoord"/>
                    </Filter>
                </section>

                <section className="mt-2.5 lg:mt-8 lg:row-start-1 lg:col-span-9">
                    <div>
                        <InfiniteScroll
                            dataLength={categoriesList?.length}
                            next={fetchMoreData}
                            hasMore={moreData}
                            className="!overflow-hidden"
                            loader={
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="animate-spin w-12 h-12 lg:w-16 lg:h-16 mx-auto mt-8 fill-olaf-orange-500"
                                >
                                    <path
                                        d="M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z"/>
                                </svg>
                            }
                        >
                            <div className="grid prodCatGrid gap-1 md:gap-2 lg:gap-3 xl:gap-4">
                                <SingleCategory
                                    id=""
                                    name="Alles"
                                    image="/assets/image/ALLES_banner.jpg"
                                    offerte={offerteId}
                                    image1={null}
                                />
                                {categoriesList?.map(({uid, id, vitemId, name, slug, image}) => (
                                    <SingleCategory
                                        key={uid}
                                        vitemId={vitemId}
                                        uid={uid}
                                        id={id}
                                        name={name}
                                        image="/assets/image/placeholder.jpg"
                                        image1={image}
                                        offerte={offerteId}
                                        slug={'/categorieen/' + slug + offerteParam}
                                    />
                                ))}
                            </div>
                        </InfiniteScroll>
                    </div>
                </section>
            </main>

            <Footer/>
        </div>
    );
}

export async function getServerSideProps(context) {
    let loggedIn = context.req.cookies["auth"] ? true : false;
    const jwtToken = context.req.cookies["auth"];

    AuthServices.cookieCheck(jwtToken, context);
    await AuthServices.refreshToken(jwtToken, context);

    const categories = await fetch(
        process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/categories?" +
        new URLSearchParams({
            limit: 20,
            page: 0,
            query: context.query.query || "",
            subcategories: context.query.subcategories || "",
        }),
        {
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    ).then((response) => response.json());

    const offerteId = context.query.offerte;

    let invoiceData = [];
    let otherInvoices = [];

    if (offerteId) {
        invoiceData = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/invoices/" + offerteId,
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        ).then((response) => response.json());

        otherInvoices = await fetch(
            process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/invoices?",
            {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        ).then((response) => response.json());
    }

    return {
        props: {
            loggedIn: loggedIn,
            jwtToken: jwtToken || null,
            categories: categories,
            offerteId: offerteId || null,
            invoiceData: invoiceData || null,
            otherInvoices: otherInvoices || null,
        }, // will be passed to the page component as props
    };
}
